import { PAGES } from "@dune/types";
import { DesignerToSubmissionFormData } from "@dune/types";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useUpdateDesignerParticipant } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { DesignerToSubmissionForm } from "../../../../component/constructionSites/submission/participants/DesignerToSubmissionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useEntityPanelSync } from "../../../../hooks/useEntityPanelSync";
import { useDesignerToSubmissionForm } from "../../../../hooks/useParticipantToSubmissionForm";

export const EditDesignerToSubmissionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId, participantId } = useParams<{
		constructionSiteId: string;
		participantId: string;
	}>();

	const updateDesignerMutation = useUpdateDesignerParticipant(
		constructionSiteId ? Number(constructionSiteId) : 0,
		participantId ? Number(participantId) : 0,
	);

	const onSubmit = (data: DesignerToSubmissionFormData) => {
		updateDesignerMutation.mutate(data, {
			onSuccess: () => {
				if (constructionSiteId) {
					navigate(PAGES.PROJECTS.submission.withParams(constructionSiteId, 4));
				}
			},
		});
	};

	const onCancel = () => {
		if (constructionSiteId) {
			navigate(PAGES.PROJECTS.submission.withParams(constructionSiteId, 4));
		}
	};

	const { form, handleSubmit } = useDesignerToSubmissionForm({
		mode: "update",
		onSubmit,
		constructionSiteId: constructionSiteId ? Number(constructionSiteId) : 0,
		participantId: participantId ? Number(participantId) : 0,
	});

	useEntityPanelSync({
		entityType: "CONSTRUCTION_SITE",
		entityId: constructionSiteId ? Number(constructionSiteId) : 0,
	});

	useEffect(() => {
		if (!constructionSiteId || !participantId) {
			navigate(PAGES.PROJECTS.index);
		}
	}, [constructionSiteId, participantId, navigate]);

	if (!constructionSiteId || !participantId) {
		return null;
	}

	return (
		<PageLayoutWithTabs title="Modifier un concepteur">
			<FormProvider {...form}>
				<form onSubmit={handleSubmit}>
					<DesignerToSubmissionForm
						constructionSiteId={Number(constructionSiteId)}
						onSubmit={handleSubmit}
						onCancel={onCancel}
						isSubmitting={updateDesignerMutation.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};
